import GeneralDialog from "../../core/GeneralDialog";

const InvoiceCommitDialog = (props: InvoiceCommitDialogProps) => {
  return props.open ? (
    <GeneralDialog
      open={props.open}
      title="請求確定"
      cancelText="編集に戻る"
      saveText="請求確定"
      onCancel={() => props.onClose()}
      onSave={() => props.onOk()}
      onClose={() => props.onClose()}
    >
      <div>
        下記の請求を確定しますか？<br /><br />
        {props.brandName}
      </div>
      <div>請求期間：{props.invoicePeriod}</div>
    </GeneralDialog>
  ) : (
    <></>
  );
};

export default InvoiceCommitDialog;

export type InvoiceCommitDialogProps = {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
  brandName: string;
  invoicePeriod: string;
};
